import Vue from 'vue'
import Vuex from 'vuex'
import snackBar from './modules/SnackBar';
import mainStore from './modules/MainStore';
import createContentStore from "./modules/CreateContentStore";
import activeLeadsStore from "./modules/ActiveLeadsStore";
import productsStore from "./modules/productsStore";
import orderPaymentStore from './modules/OrderPaymentStore'
import queryStore from "./modules/QueryStore"
import dashboardStore from './modules/dashboardStore'
import StateFilterStore from './modules/StateFilterStore'
import crmFilters from './modules/CrmFilters'

Vue.use(Vuex)

export default new Vuex.Store({
  namespaced : true,
  modules : {
    snackBar,
    mainStore,
    createContentStore,
    activeLeadsStore,
    productsStore,
    orderPaymentStore,
    queryStore,
    dashboardStore,
    StateFilterStore,
    crmFilters
  }
})
